module.exports = __webpack_public_path__ + "img/redetop.0b84df32.png";